import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../utils/api';
import { useNotification } from '../../context/NotificationContext';

const AppointmentAnalytics = () => {
  const { showError } = useNotification();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const [interactionsRes] = await Promise.all([
        adminAPI.getInteractionVolume()
      ]);
      if (interactionsRes.data?.success) {
        setData(interactionsRes.data.data);
      }
    } catch (error) {
      showError('Failed to load analytics');
    } finally {
      setLoading(false);
    }
  };

  const statusColors = {
    requested: 'text-yellow-400',
    accepted: 'text-blue-400',
    completed: 'text-green-400',
    cancelled: 'text-red-400'
  };

  if (loading) {
    return <div className="p-6 text-center text-gray-400">Loading analytics...</div>;
  }

  const total = Array.isArray(data)
    ? data.reduce((sum, item) => sum + item.count, 0)
    : 0;

  const byStatus = Array.isArray(data)
    ? data.reduce((acc, item) => {
        const status = item._id?.status || 'unknown';
        acc[status] = (acc[status] || 0) + item.count;
        return acc;
      }, {})
    : {};

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-gold">Appointment Analytics</h1>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-gray-800 rounded-xl p-4 text-center">
          <p className="text-3xl font-bold text-gold">{total}</p>
          <p className="text-gray-400 text-sm mt-1">Total Consultations</p>
        </div>
        <div className="bg-gray-800 rounded-xl p-4 text-center">
          <p className="text-3xl font-bold text-gold">{Object.keys(byStatus).length}</p>
          <p className="text-gray-400 text-sm mt-1">Status Types</p>
        </div>
      </div>

      <div className="space-y-3">
        <h2 className="text-lg font-semibold">By Status</h2>
        {Object.entries(byStatus).length === 0 ? (
          <p className="text-gray-400 text-center py-6">No consultation data available</p>
        ) : (
          Object.entries(byStatus).map(([status, count]) => (
            <div key={status} className="bg-gray-800 rounded-xl p-4 flex justify-between items-center">
              <span className={`font-medium capitalize ${statusColors[status] || 'text-gray-300'}`}>
                {status.replace(/_/g, ' ')}
              </span>
              <span className="text-xl font-bold">{count}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AppointmentAnalytics;
